import DATA_INTRO_TRANSFORMER from "./Introduction/201DataIntroTransformer";

const TRANSFOMER_WORKFLOW = [
  {
    page: 201,
    type: "intro-template" as TemplateType,
    data: DATA_INTRO_TRANSFORMER,
  },
];

export default TRANSFOMER_WORKFLOW;
